import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BusyOverlayComponent } from 'app/core/busy/busy-overlay.component';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss'],
    standalone : true,
    imports    : [RouterOutlet, BusyOverlayComponent],
})
export class AppComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
